/* eslint-disable max-len */
import React from 'react'
import { createIcon } from '@chakra-ui/icon'

const URLEndpoint = createIcon({
  viewBox: '0 0 21 20',
  displayName: 'URLEndpoint',
  path: (
    <>
      <path
        d="M8.21094 10.9018C8.5975 11.4188 9.09073 11.8465 9.65716 12.1561C10.2236 12.4656 10.85 12.6497 11.4938 12.6958C12.1376 12.742 12.7839 12.6491 13.3887 12.4235C13.9934 12.1979 14.5426 11.8449 14.999 11.3884L17.6996 8.68775C18.5437 7.84363 19.0179 6.69876 19.0179 5.505C19.0179 4.31123 18.5437 3.16636 17.6996 2.32225C16.8555 1.47813 15.7106 1.00391 14.5169 1.00391C13.3231 1.00391 12.1782 1.47813 11.3341 2.32225L9.7868 3.86167"
        stroke="#E0E4EC"
        fill="transparent"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8066 9.09849C11.42 8.58155 10.9268 8.1538 10.3604 7.84426C9.79393 7.53472 9.16755 7.35064 8.52371 7.30449C7.87987 7.25834 7.23364 7.35121 6.62886 7.5768C6.02407 7.80239 5.47488 8.15542 5.01854 8.61194L2.31791 11.3126C1.89994 11.7307 1.56843 12.2271 1.34231 12.7734C1.11618 13.3197 0.999863 13.9051 1 14.4964C1.00014 15.0876 1.11672 15.673 1.3431 16.2192C1.56948 16.7654 1.90123 17.2616 2.31938 17.6796C2.73754 18.0975 3.23393 18.429 3.78021 18.6552C4.32649 18.8813 4.91195 18.9976 5.50318 18.9975C6.09441 18.9973 6.67982 18.8807 7.22599 18.6544C7.77217 18.428 8.2684 18.0962 8.68637 17.6781L10.2258 16.1387"
        stroke="#E0E4EC"
        fill="transparent"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
})

export default URLEndpoint
